<template>
<div>
  <!-- LANDING LOGO -->
  <div class="landing">
    <smash-logo class="landing__logo"></smash-logo>
  </div>

  <div class="story">
    <scroll-view :offset="82">
      <template slot-scope="visibility">
        <!-- INTRO MARKER -->
        <scroll-marker
          name="intro"
          key="introMarker"
          :visible="visibility.introMarker"
          @isVisible="markerVisible"
          @isNotVisible="markerNotVisible"
        ></scroll-marker>
        <!-- INTRO CONTENT -->
        <intro-view key="introContent" :visible="visibility.introContent"></intro-view>
        <!-- FIRST MARKEr -->
        <scroll-marker
          name="first"
          key="firstMarker"
          :spacing=600
          :visible="visibility.firstMarker"
          @isVisible="markerVisible"
          @isNotVisible="markerNotVisible"
        ></scroll-marker>
        <!-- FIRST CONTENT -->
        <first-view key="firstContent" :visible="visibility.firstContent"></first-view>
        <!-- SECOND MARKER -->
        <scroll-marker
          name="second"
          key="secondMarker"
          :spacing=600
          :visible="visibility.secondMarker"
          @isVisible="markerVisible"
          @isNotVisible="markerNotVisible"
        ></scroll-marker>
        <!-- SECOND CONTENT -->
        <second-view key="secondContent" :visible="visibility.secondContent"></second-view>
        <!-- THIRD MARKER -->
        <scroll-marker
          name="third"
          key="thirdMarker"
          :spacing=600
          :visible="visibility.thirdMarker"
          @isVisible="markerVisible"
          @isNotVisible="markerNotVisible"
        ></scroll-marker>
        <!-- THIRD CONTENT -->
        <third-view key="thirdContent" :visible="visibility.thirdContent"></third-view>
        <!-- FOURTH MARKER -->
        <scroll-marker
          name="fourth"
          key="fourthMarker"
          :spacing=600
          :visible="visibility.fourthMarker"
          @isVisible="markerVisible"
          @isNotVisible="markerNotVisible"
        ></scroll-marker>
        <!-- FOURTH CONTENT -->
        <fourth-view key="fourthContent" :visible="visibility.fourthContent"></fourth-view>
        <!-- FIFTH MARKER -->
        <scroll-marker
          name="fifth"
          key="fifthMarker"
          :spacing=600
          :visible="visibility.fifthMarker"
          @isVisible="markerVisible"
          @isNotVisible="markerNotVisible"
        ></scroll-marker>
        <!-- FIFTH CONTENT -->
        <fifth-view key="fifthContent" :visible="visibility.fifthContent"></fifth-view>
        <!-- SIXTH MARKER -->
        <scroll-marker
          name="sixth"
          key="sixthMarker"
          :spacing=600
          :visible="visibility.sixthMarker"
          @isVisible="markerVisible"
          @isNotVisible="markerNotVisible"
        ></scroll-marker>
        <!-- SIXTH CONTENT -->
        <sixth-view key="sixthContent" :visible="visibility.sixthContent"></sixth-view>
         <!-- SEVENTH MARKER -->
        <scroll-marker
          name="seventh"
          key="seventhMarker"
          :spacing=600
          :visible="visibility.seventhMarker"
          @isVisible="markerVisible"
          @isNotVisible="markerNotVisible"
        ></scroll-marker>
        <!-- SEVENTH CONTENT -->
        <seventh-view key="seventhContent" :visible="visibility.seventhContent"></seventh-view>
        <!-- FINDINGS MARKER -->
        <scroll-marker
          name="findings"
          key="findingsMarker"
          :spacing=600
          :visible="visibility.findingsMarker"
          @isVisible="markerVisible"
          @isNotVisible="markerNotVisible"
        ></scroll-marker>
        <!-- FINDINGS CONTENT -->
        <findings-view key="findingsContent" :visible="visibility.findingsContent"></findings-view>
        
      </template>
    </scroll-view>
  </div>
  
</div>
</template>

<script>
/* eslint-disable */
import { mapMutations } from 'vuex'
import { $scrollview } from 'vue-scrollview'
import SmashLogo from './Logo'

import views from './views'

export default {
  name: 'Scroller',
  data() {
      return {
          markerNames: ['first', 'second', 'third', 'fourth', 'fifth', 'end']
      }
  },
  components: {
    SmashLogo,
    ...views
  },
  methods: {
      ...mapMutations([ 'update_view', 'update_scrollDirection' ]),
      markerVisible(name) {
        this.update_view(name)
        this.update_scrollDirection($scrollview.getScrollDirection())
      },
      markerNotVisible(view) {
        if (view === 'intro' && $scrollview.getScrollDirection() === 'UP' ) {
          this.update_view('landing')
          this.update_scrollDirection($scrollview.getScrollDirection())
        }
      }
  }
}
</script>

<style scoped>

.story {
  width: 30vw;
  padding-left: 17px;
}

@media (min-width: 1600px) {
  .story {
    padding-left: 10vw;
  }
}

.landing__logo {
  width: 100vw;
  min-height: 100vh;
  max-height: 100vh;
}

</style>
